import React, { useState } from "react";
import { toast } from "react-toastify";
import { CONFIGURE_API } from "../../constants/api";
import { useNavigate } from "react-router-dom";

function AddNewInclude() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(true);
  const [time, setTime] = useState("");
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Submitting Service Details...");

    const include = { title, description, time, status };

    try {
      const response = await fetch(CONFIGURE_API + "/includes/create", {
        method: "POST",
        body: JSON.stringify(include),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (!response.ok) {
        toast.dismiss(loadingToastId);
        toast.error(json.message);
      } else {
        toast.dismiss(loadingToastId);
        navigate("/auth/allServices")
        toast.success("Service added successfully!");
      }
    } catch (error) {
      console.error("Error creating Service:", error);
      toast.dismiss(loadingToastId);
      toast.error("An error occurred while creating.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <h2 className="mb-5">Create New Service</h2>

      <div className="header-body">
        <div className="card">
          <div className="card-body">
            <form
              onSubmit={handleSubmit}
              className="row g-3 needs-validation"
              noValidate
            >
              <div className="col-md-6">
                <label htmlFor="inputCity" className="form-label">
                  Title
                </label>
                <input
                  type="text"
                  onChange={(e) => setTitle(e.target.value)}
                  className="form-control"
                  id="inputCity"
                  required
                  placeholder="e.g. Static Social Media Posts"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="inputState" className="form-label">
                  Time
                </label>
                <input
                  type="number"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  className="form-control"
                  id="inputCity"
                  required
                  placeholder="enter time in hours (e.g. 24)"
                />
              </div>

              <div className="col-md-12">
                <label htmlFor="inputZip" className="form-label">
                  Description
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  id="inputZip"
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={status}
                    id="flexCheckIndeterminate"
                    onChange={(e) => setStatus(e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckIndeterminate"
                  >
                    Active
                  </label>
                </div>
              </div>

              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-dark float-right"
                  style={{ color: "white", background: "black" }}
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewInclude;
